import gql from 'graphql-tag';

export default gql`
mutation UpsertCourseLearningAnswers($survey: CourseLearningAnswersInput!) {
  upsertCourseLearningAnswers(input: $survey) {
    id
  }
}
`;
